import { useEditor } from "@craftjs/core";
import * as React from "react";

import RegistrationWidget from "@/components/registration-widget/registration-widget-component";

import { RegisterButton } from "./event-card-styles";

interface RelatedEventsRegisterButtonProps {
  seriesExternalId: string;
  eventSlug: string;
}

export default function RelatedEventsRegisterButton(
  props: RelatedEventsRegisterButtonProps
) {
  const [isTicketSelectorOpen, setTicketSelectorOpen] = React.useState(false);
  const { isEditing } = useEditor((state) => ({
    isEditing: state.options.enabled,
  }));

  const { seriesExternalId, eventSlug } = props;

  const handlers = React.useMemo(() => {
    const handlers: Record<string, any> = {
      onClick: (event) => {
        if (isEditing) {
          event.preventDefault();
          return;
        }
        setTicketSelectorOpen(true);
      },
    };

    return handlers;
  }, [isEditing]);

  return (
    <>
      <RegistrationWidget
        isOpen={isTicketSelectorOpen}
        onClose={() => setTicketSelectorOpen(false)}
        eventSlug={eventSlug}
        seriesExternalId={seriesExternalId}
      />
      <RegisterButton {...handlers} className="button-primitive">
        Register
      </RegisterButton>
    </>
  );
}
